// Copied/adapted from `pdt-old/pdtToXdm.mapper.ts` (do not modify old files).

import { PDT_CONFIG } from './constants';
import { calculateAdvancePurchase } from './utils';
import { FUNNEL_STEP } from '../xdm.constants';

export type SearchArgumentsForXdm = {
  from: { code: string | null; name: string | null };
  to: { code: string | null; name: string | null };
  date?: Date | null;
  queryParams?: { source?: string | null };
  searchType?: string | null;
  tripType?: string | null;
  pageName?: string | null;
};

export type XdmSearchContext = {
  from: { location: { code: string | null; name: string | null } };
  to: { location: { code: string | null; name: string | null } };
  from_date_time: number | null;
  advance_purchase: string | null;
  search_type?: string | null;
  trip_type?: string | null;
  page_name?: string | null;
};

export const mapSearchContextToXdm = ({
  searchArguments,
}: {
  searchArguments: SearchArgumentsForXdm;
}): XdmSearchContext => {
  const fromCode = searchArguments?.from?.code ?? null;
  const fromName = searchArguments?.from?.name ?? null;
  const toCode = searchArguments?.to?.code ?? null;
  const toName = searchArguments?.to?.name ?? null;

  const departureTime = searchArguments?.date?.getTime?.() ?? null;
  const advancePurchase =
    calculateAdvancePurchase(searchArguments?.date || undefined) ?? null;

  return {
    from: { location: { code: fromCode, name: fromName } },
    to: { location: { code: toCode, name: toName } },
    from_date_time: departureTime,
    advance_purchase: advancePurchase,
    // New fields (optional) for richer attribution
    search_type: searchArguments?.searchType ?? null,
    trip_type: searchArguments?.tripType ?? null,
  };
};

export const createPageContext = ({
  pageName,
  prevPageName,
  pageTitle,
  pageUrl,
  pageType,
}: {
  pageName: string;
  prevPageName: string | null;
  pageTitle: string | null;
  pageUrl: string | null;
  pageType?: string;
}) => {
  return {
    lob: 'bus',
    page_name: pageName ?? null,
    page_type: pageType ?? 'template',
    // SEO-only renderer: funnel step is constant here.
    funnel_step: FUNNEL_STEP.LISTING,
    lob_category: 'bus',
    prev_page_name: prevPageName ?? null,
    page_title: pageTitle ?? null,
    page_url: pageUrl ?? null,
    travel_store: { store_id: 'MMT' },
  };
};

export const createEventDetail = ({
  eventName,
  eventType,
  eventValue,
}: {
  eventName: string;
  eventType: string;
  eventValue: string;
}) => {
  return {
    event_name: eventName,
    event_type: eventType,
    event_value: eventValue,
    event_timestamp: Date.now(),
    components: null,
  };
};

export const createEventTrackingContext = ({
  journeyId,
}: {
  journeyId: string | null;
}) => {
  return {
    journey_id: journeyId ?? null,
    bu: 'ground_transport',
    organisation: 'MMT',
    domain_country: 'IN',
    domain_language: 'eng',
    domain_currency: 'INR',
    // Match live payload
    env: 'production',
    funnel_source: 'SEO',
    funnel_entry: 'SEO',
    traffic_source: 'SEO',
    template_id: PDT_CONFIG.TEMPLATE_ID,
    topic_name: PDT_CONFIG.TOPIC_NAME,
  };
};
